import { ReactElement, useContext, useState, useCallback } from "react";
import { FormConfig } from "@evergiving/common/dist/es2015/form";

import {
  backgroundImageWidths,
  backgroundImageFormats,
} from "@/lib/config/constants";
import { placeholderImageData } from "@/lib/config/placeholder";
import { FormContext } from "./FormContext";
import { useMatchMedia } from "@/lib/hooks/useMatchMedia";

const emptyPng =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==l";

export function BackgroundImage({
  formConfig,
}: {
  formConfig: FormConfig;
}): ReactElement | null {
  const formContext = useContext(FormContext);

  const [loaded, setLoaded] = useState(false);

  const handleOnLoad = useCallback(() => {
    setLoaded(true);
  }, []);

  const isLargeWindow = useMatchMedia("(min-width: 769px)");

  if (process.env.PREVIEW_MODE === "true") {
    return (
      <picture className="background">
        <img src={formConfig.backgroundImageUrl} alt="Background" />
      </picture>
    );
  }

  return (
    <>
      {!loaded && isLargeWindow !== false && (
        <>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="0"
            height="0"
          >
            <filter id="blur">
              <feGaussianBlur stdDeviation="30" />
              <feColorMatrix
                type="matrix"
                values="1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0"
              ></feColorMatrix>
              <feComposite in2="SourceGraphic" operator="in"></feComposite>
            </filter>
          </svg>
          <picture className="backgroundPlaceholder">
            <source
              srcSet={`${emptyPng} 1w, ${placeholderImageData} 1000w`}
              sizes="(max-width: 768px) 1px, 100vw"
              type="image/jpeg"
            />
            <img src={emptyPng} />
          </picture>
        </>
      )}
      {isLargeWindow === true && (
        <picture className="background" onLoad={handleOnLoad}>
          {Object.keys(backgroundImageFormats).map((format) => (
            <source
              key={format}
              srcSet={
                `${emptyPng} 1w, ` +
                backgroundImageWidths
                  .map(
                    (width) =>
                      `${formContext.basePath}/_next/static/background_${width}.${format} ${width}w`
                  )
                  .join(", ")
              }
              sizes="(max-width: 768px) 1px, (min-width: 769px) 100vw"
              type={`image/${format}`}
            />
          ))}
          <img src={emptyPng} />
        </picture>
      )}
    </>
  );
}
